import { useTranslation } from 'next-i18next';
import { FC, useMemo } from 'react';

import { FIRST_LINE_KEYS, IWhatToSeeCardData } from './whatToSeeCardsData';

import { Button } from '@/components/shared/Button';
import { Link } from '@/components/shared/Link';
import { formatPathname } from '@/helpers/routing';
import { useLocale } from '@/hooks/useLocale';
import { Colors } from '@/types';

interface IWhatToSeeCardProps {
  cardData: IWhatToSeeCardData;
}

export const WhatToSeeCard: FC<IWhatToSeeCardProps> = ({ cardData: { titleKey, image, cardKey, page_slug } }) => {
  const { t } = useTranslation();
  const { isEnLocale } = useLocale();

  const mdColSpanClass = useMemo<string>(
    () => (FIRST_LINE_KEYS.includes(cardKey) ? 'md:col-span-3' : 'md:col-span-2'),
    [cardKey],
  );

  return (
    <div
      className={`relative col-span-6 flex h-[200px] flex-wrap items-center justify-center p-4 md:h-[340px] ${mdColSpanClass}`}
    >
      <div
        style={{ backgroundImage: `url(${image})` }}
        className="absolute h-full w-full rounded-md bg-cover bg-center brightness-75"
      />

      <div className="z-10 text-center">
        <h3
          className={`flex h-16 w-full max-w-[15rem] items-center justify-center text-xl text-white md:h-24 md:text-[34px] lg:h-32 ${
            isEnLocale ? '' : 'mb-4'
          }`}
        >
          {t(titleKey)}
        </h3>

        {!isEnLocale && (
          <Link href={formatPathname(page_slug)}>
            <Button className="text-base md:!text-base-md" variant={Colors.black} type="button">
              {t('buttons.find-out-more')}
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
};
